var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.795898,
    y: 0.499023,
    width: 36,
    height: 36,
    rx: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1598_19170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0459 11.749H13.5459C12.5517 11.7502 11.5986 12.1457 10.8956 12.8487C10.1926 13.5517 9.79709 14.5048 9.7959 15.499H27.7959C27.7947 14.5048 27.3992 13.5517 26.6962 12.8487C25.9932 12.1457 25.0401 11.7502 24.0459 11.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7959 21.499C9.79709 22.4932 10.1926 23.4463 10.8956 24.1493C11.5986 24.8524 12.5517 25.2478 13.5459 25.249H24.0459C25.0401 25.2478 25.9932 24.8524 26.6962 24.1493C27.3992 23.4463 27.7947 22.4932 27.7959 21.499V16.999H9.7959V21.499ZM15.0459 21.124C15.0459 21.3465 14.9799 21.564 14.8563 21.749C14.7327 21.934 14.557 22.0782 14.3514 22.1634C14.1459 22.2485 13.9197 22.2708 13.7014 22.2274C13.4832 22.184 13.2827 22.0768 13.1254 21.9195C12.9681 21.7622 12.8609 21.5617 12.8175 21.3435C12.7741 21.1253 12.7964 20.8991 12.8815 20.6935C12.9667 20.4879 13.1109 20.3122 13.2959 20.1886C13.4809 20.065 13.6984 19.999 13.9209 19.999C14.2193 19.999 14.5054 20.1175 14.7164 20.3285C14.9274 20.5395 15.0459 20.8256 15.0459 21.124Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1598_19170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9.7959 9.49902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge2);
export default __webpack_public_path__ + "static/media/badge-2.a4f6a30f37ccb2cb390980bd10be7d5d.svg";
export { ForwardRef as ReactComponent };